import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import './index.scss'
import PrivateLandDetails from '../privateLandDetails'
import { landTrustDetailsMenuBarexpand, landTrustDetailsMenuBarHide } from '../../../../action/land-trust-menu-bar'
import { fetchPrivateRemoveMarkersAction } from '../../../../action/private-land-markers'

const LandTrustItems = (props) => {

  let { landTrustRightMenuBarObj } = props
  let [openItem, setOpenItem] = useState(false)
  let [itemDetails, setItemDetails] = useState()
  const [privateLandsItems, setPrivateLandsItems] = useState([])
  useEffect(() => {
    setPrivateLandsItems(props.privateLandItems)
  }, [props.privateLandItems])

  let onClickItem = (item) => {
    setOpenItem(true)
    setItemDetails(item)
    props.landTrustDetailsMenuBarexpand()
    removeMarkersFromMap()
  }

  const removeMarkersFromMap = () => {
    if (!props.privateLandsMarkersMapObj || props.privateLandsMarkersMapObj.length === 0) return;
    props.privateLandsMarkersMapObj.forEach(marker => {
      const mapObj = marker; // call the function if it exists
      if (mapObj) {
        mapObj.map = null; // Remove the marker from the map
      }
    });
    props.fetchPrivateRemoveMarkersAction()
  };

  return (
    <div>
      {!props.loading && privateLandsItems.length > 0 && privateLandsItems.map((item, index) => {
        return (
          <>
            {item.imageUrl &&
              <div className='pl-items-container' key={index} onClick={() => onClickItem(item)}>
                <img src={item.imageUrl}></img>
                <div className='pl-items-container-details'>
                  <h3>{item.title}</h3>
                  <p>{item.location}</p>
                  <p>{item.state}</p>
                </div>
              </div>
            }
          </>
        )
      })
      }


      {(props.lantTrustPrivateLandDetails || landTrustRightMenuBarObj.expanded) && <PrivateLandDetails itemDetails={landTrustRightMenuBarObj.activityDetails ? landTrustRightMenuBarObj.activityDetails : itemDetails}></PrivateLandDetails>}

    </div>
  )
}

const mapStateToProps = state => ({
  privateLandItems: state.privateLandItems,
  privateLandFilterValues: state.privateLandFilterValues,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  privateLandsMarkersMapObj: state.privateLandsMarkersMapObj,
  landTrustRightMenuBarObj: state.landTrustRightMenuBarObj
})

const mapDispatchToProps = dispatch => ({
  landTrustDetailsMenuBarexpand: () => dispatch(landTrustDetailsMenuBarexpand()),
  landTrustDetailsMenuBarHide: () => dispatch(landTrustDetailsMenuBarHide()),
  fetchPrivateRemoveMarkersAction: () => dispatch(fetchPrivateRemoveMarkersAction())
})

export default connect(mapStateToProps, mapDispatchToProps)(LandTrustItems)